import { render, staticRenderFns } from "./ReceivableCheckModal.vue?vue&type=template&id=71881b90&scoped=true&"
import script from "./ReceivableCheckModal.vue?vue&type=script&lang=js&"
export * from "./ReceivableCheckModal.vue?vue&type=script&lang=js&"
import style0 from "./ReceivableCheckModal.vue?vue&type=style&index=0&id=71881b90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71881b90",
  null
  
)

export default component.exports